"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSignaturesConcurrently = computeSignaturesConcurrently;
const fs_1 = require("fs");
const hash_1 = require("./hash");
const common_1 = require("./common");
const debug_1 = require("./debug");
const pMap = require("p-map");
const { readFile } = fs_1.promises;
async function computeSignaturesConcurrently(paths) {
    const start = Date.now();
    const result = pMap(paths, async (path) => {
        const content = await readFile(path);
        return await (0, hash_1.computeHash)(path, content);
    }, { concurrency: common_1.HASHING_CONCURRENCY_LEVEL });
    const totalMilliseconds = Date.now() - start;
    (0, debug_1.debug)(`elapsed time in pMap: ${totalMilliseconds} ms \n`);
    return result;
}
//# sourceMappingURL=signatures.js.map